@let custom = customEmojiData();
@let emojiId = resolvedEmojiId();

@if (custom) {
  <spaces-animated-image
    class="custom-emoji-img"
    [src]="custom.imageUrl"
    [alt]="custom.name"
    [style.width.px]="size() ?? 24"
    [style.height.px]="size() ?? 24"
    [attr.data-pw]="'emoji-' + custom.id"
  ></spaces-animated-image>
} @else if (emojiId) {
  @if (isNative) {
    <span
      class="emoji-native"
      [style.font-size.px]="size() ?? 24"
      [attr.data-pw]="'emoji-' + emojiId"
    >{{ nativeChar() }}</span>
  } @else {
    <span
      [class]="spriteClass()"
      [style.width.px]="size() ?? 24"
      [style.height.px]="size() ?? 24"
      [attr.data-pw]="'emoji-' + emojiId"
    ></span>
  }
}
